export function createGiftVoucherHtml({ code, productName, productPeriod }) {
    return `
<!DOCTYPE html>
<html lang="de">
  <head>
    <meta charset="utf-8" />
    <title>Geschenkcode - ${code}</title>
    <meta name="viewport" content="width=device-width, initial-scale=1" />

    <style>
      /* --- Druckeinstellungen --- */
      @page {
        size: A4;
        margin: 20mm;
      }

      * {
        box-sizing: border-box;
      }

      body {
        margin: 0;
        padding: 0;
        font-family: system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI",
          Roboto, sans-serif;
        background: #f3f4f6;
        color: #111827;
      }

      .page {
        min-height: 100vh;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 24px;
      }

      :root {
        --hkcm-blue: #2563eb;
        --hkcm-dark: #111827;
        --hkcm-grey: #6b7280;
        --hkcm-border: #e5e7eb;
      }

      .voucher {
        position: relative;
        max-width: 720px;
        width: 100%;
        background: white;
        border-radius: 16px;
        border: 1px solid var(--hkcm-border);
        padding: 40px 48px 36px;
        box-shadow: 0 14px 40px rgba(15, 23, 42, 0.15);
      }

      .voucher::before {
        content: "";
        position: absolute;
        inset: 18px;
        border-radius: 12px;
        border: 1px dashed var(--hkcm-blue);
        pointer-events: none;
      }

      .voucher-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 32px;
      }

      .voucher-logo img {
        width: 100px;
        height: auto;
      }

      .voucher-tag {
        font-size: 11px;
        text-transform: uppercase;
        letter-spacing: 0.12em;
        padding: 4px 10px;
        border-radius: 999px;
        border: 1px solid rgba(37, 99, 235, 0.25);
        background: rgba(37, 99, 235, 0.05);
        color: var(--hkcm-blue);
        font-weight: 600;
      }

      .voucher-title {
        text-align: center;
        margin-bottom: 12px;
      }

      .voucher-title h1 {
        margin: 0;
        font-size: 26px;
        letter-spacing: 0.04em;
        text-transform: uppercase;
        font-weight: 800;
      }

      .voucher-subtitle {
        margin-top: 6px;
        font-size: 14px;
        color: var(--hkcm-grey);
      }

      .tier-label {
        margin-top: 16px;
        font-size: 15px;
        text-transform: uppercase;
        letter-spacing: 0.18em;
        color: var(--hkcm-grey);
      }

      .tier-name {
        margin-top: 6px;
        font-size: 18px;
        font-weight: 700;
        color: var(--hkcm-blue);
      }

      .code-block {
        margin-top: 32px;
        padding: 22px 24px;
        border-radius: 12px;
        background: linear-gradient(
          135deg,
          rgba(37, 99, 235, 0.06),
          rgba(59, 130, 246, 0.02)
        );
        border: 1px solid rgba(37, 99, 235, 0.25);
        text-align: center;
      }

      .code-label {
        font-size: 12px;
        letter-spacing: 0.16em;
        text-transform: uppercase;
        color: var(--hkcm-grey);
        margin-bottom: 4px;
      }

      .code-value {
        font-family: "SF Mono", ui-monospace, Menlo, Monaco, Consolas,
          "Liberation Mono", "Courier New", monospace;
        font-size: 28px;
        font-weight: 800;
        color: var(--hkcm-blue);
        margin-top: 6px;
      }

      .info-row {
        margin-top: 28px;
        font-size: 12px;
        color: var(--hkcm-grey);
        display: flex;
        justify-content: space-between;
      }

      .info-row strong {
        color: var(--hkcm-dark);
        font-weight: 600;
      }

      .small-print {
        margin-top: 16px;
        font-size: 10px;
        color: #9ca3af;
        line-height: 1.4;
      }

      @media print {
        body { background: white; }
        .page { padding: 0; }
        .voucher { box-shadow: none; }
        .voucher::before { border: none; }
      }
    </style>
  </head>

  <body>
    <div class="page">
      <div class="voucher">

        <div class="voucher-header">
          <div class="voucher-logo">
            <img
              src="https://asset.hkcmanagement.de/5a21cba7-fc95-4025-aa69-8abf33c54c48/hkcm/images/logo-on-light-background.svg"
              alt="HKCM Logo"
            />
          </div>
          <div class="voucher-tag">Geschenkgutschein</div>
        </div>

        <div class="voucher-title">
          <h1>Geschenkgutschein</h1>
          <div class="voucher-subtitle">Für Ihre nächste Analyse bei HKCM</div>
        </div>

        <div class="tier-label">Produkt</div>
        <div class="tier-name">${productName} / ${productPeriod}</div>

        <div class="code-block">
          <div class="code-label">Gutscheincode</div>
          <div class="code-value">${code}</div>
        </div>

        <div class="info-row">
          <div>
            <strong>Einzulösen unter:</strong><br />
            hkcmanagement.de/geschenk
          </div>
        </div>

        <div class="small-print">
          Dieser Gutschein ist nicht übertragbar und nur einmal verwendbar.
          Eine Barauszahlung ist ausgeschlossen. Es gelten die AGB der
          Hopf-Klinkmüller Capital Management (HKCM).
        </div>

      </div>
    </div>
  </body>
</html>`;
}
